import InformationCard from '@stories/Components/Cards/InformationCard/InformationCard';
import * as React from 'react';
import S from './BranchDetails.styles';
import MapArea from './MapArea/MapArea';
const BranchDetails = (props) => {
    return (React.createElement(S.Container, { site: props.site, spacing: 'padding' },
        React.createElement(S.MapContainer, null,
            React.createElement(S.MapInner, null,
                React.createElement(MapArea, { position: { lat: props.latitude, lng: props.longitude }, site: props.site ?? 'ess' }))),
        React.createElement(S.CardsContainer, null,
            React.createElement(S.Card, null,
                React.createElement(InformationCard, { site: props.site, icon: props.contactIcon, title: props.contactTitle ?? 'Contact Details', content: `${props.address ? props.address : ''}
            <p><strong>T: </strong>${props.contactPhone}</p> ${props.contactEmail ? `<p><strong>E: </strong>${props.contactEmail}</p>` : ''}` })),
            props.openingHours && props.openingHours.length > 0 ? (React.createElement(S.Card, null,
                React.createElement(InformationCard, { site: props.site, icon: props.openingHoursIcon, title: props.openingHoursTitle ?? 'Opening Hours', content: props.openingHours
                        .map((oh) => `<p><strong>${oh.title}: </strong> ${oh.text}</p>`)
                        .join('') }))) : null)));
};
export default BranchDetails;
